<template lang="pug">
  .agreements-and-rules
    .row(v-if="registration.policies().length>0")
      .columns.large-24
        article.content-block
          header
            .title
              |{{t('app.registration.policies')}}
          section.content
            p.small
              | {{t('app.registration.policies_helper')}}
            .policies
              Policies
    .row(v-if="registration.agreements().length>0")
      .columns.large-24
        article.content-block
          header
            .title
              | {{t('app.registration.agreements')}}
          section.content
            p.small
              | {{t('app.registration.agreements_helper')}}
              br
            Agreements
            br
            br
            p.small.agreements_agreement
              | {{t('app.registration.agreements_agreement')}}
    AdditionalData
</template>

<script>
import helpers from 'code/base_mixins'
import AdditionalData from '../_additional_data'
import Agreements from '../_agreements'
import Policies from '../_policies'
export default {
  name: "agreements_and_rules",
  components: {AdditionalData,Agreements,Policies},
  mixins: [helpers],
  computed: {
    registration(){
      return this.state.current_reg
    },
  }
}
</script>
<style scoped>
.agreements_agreement{
  line-height: initial;
}
</style>
